"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IndexBar = /** @class */ (function (_super) {
    __extends(IndexBar, _super);
    function IndexBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexBar.prototype.getPreWidth = function () {
        var width = parseInt(this.props.width, 10);
        var threshold = parseInt(this.props.extraWidth, 10);
        return (width < threshold ? width : threshold) + "%";
    };
    IndexBar.prototype.getPostWidth = function () {
        var width = parseInt(this.props.width, 10);
        var threshold = parseInt(this.props.extraWidth, 10);
        return (width > threshold ? width - threshold : 0) + "%";
    };
    IndexBar.prototype.render = function () {
        return (React.createElement("div", { className: "bar" },
            React.createElement("div", null,
                React.createElement("span", { className: "pre", style: { width: this.getPreWidth() } }),
                React.createElement("span", { className: "post", style: { width: this.getPostWidth() } }))));
    };
    return IndexBar;
}(React.Component));
exports.default = IndexBar;
//# sourceMappingURL=index-bar.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Bar/index-bar.js
// module id = 236
// module chunks = 0